export default __webpack_public_path__ + "static/media/jodi_digit.f8e2bbcb.png";